import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import config from '../functions/config';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTachometerAlt,
  faUsers,
  faRightFromBracket,
  faBook,
  faListCheck,
  faCartShopping,
  faBagShopping,
} from "@fortawesome/free-solid-svg-icons";

const EditBook = () => {
  const { id } = useParams(); // Get the book ID from the URL
  const navigate = useNavigate();
  const [bookDetails, setBookDetails] = useState({
    title: '',
    author: '',
    publisher: '',
    stock: 0,
    price: 0,
  });

  const [notification, setNotification] = useState(null);

  // Fetch book details when the component mounts
  useEffect(() => {
    const fetchBookDetails = async () => {
      try {
        const response = await fetch(`${config.BASE_URL}/api/register-book/${id}/`);
        if (response.ok) {
          const data = await response.json();
          setBookDetails(data); // Populate form fields with the fetched data
        } else {
          console.error('Failed to fetch book details');
        }
      } catch (error) {
        console.error('Error fetching book details:', error);
      }
    };

    fetchBookDetails();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBookDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${config.BASE_URL}/api/register-book/${id}/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bookDetails),
      });

      if (response.ok) {
        setNotification({ type: "success", message: "Book updated successfully!" });
        setTimeout(() => {
          navigate('/view-books'); // Redirect to the homepage or another page
        }, 3000);
      } else {
        setNotification({ type: "error", message: "Failed to update the book." });
      }
    } catch (error) {
      console.error('Error updating the book:', error);
      setNotification({ type: "error", message: "An error occurred. Please try again." });
    }
  };

  // Auto-dismiss notification after 3 seconds
  useEffect(() => {
    if (notification) {
      const timer = setTimeout(() => setNotification(null), 3000);
      return () => clearTimeout(timer);
    }
  }, [notification]);

  return (
    <div>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-light fixed-top">
  <a className="navbar-brand text-light" href="#">
    Admin 
  </a>
  <button
    className="navbar-toggler bg-light"
    type="button"
    data-bs-toggle="collapse"
    data-bs-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span className="navbar-toggler-icon"></span>
  </button>
  <div className="collapse navbar-collapse" id="navbarSupportedContent">
  <ul className="navbar-nav mr-auto flex-column vertical-nav px-3">
<li className="nav-item">
  <a className="nav-link text-light" href="/admin">
    <span className="nav-icon">
      <FontAwesomeIcon icon={faTachometerAlt} />
    </span>
    <span className="nav-text">Dashboard</span>
  </a>
</li>
<li className="nav-item">
  <a className="nav-link text-light" href="/register-book">
    <span className="nav-icon">
      <FontAwesomeIcon icon={faBook} />
    </span>
    <span className="nav-text text-warning">Register Book</span>
  </a>
</li>
<li className="nav-item">
  <a className="nav-link text-light" href="/list-users">
    <span className="nav-icon">
      <FontAwesomeIcon icon={faUsers} />
    </span>
    <span className="nav-text">Manage User</span>
  </a>
</li>
<li className="nav-item">
  <a className="nav-link text-light" href="/view-books">
    <span className="nav-icon">
      <FontAwesomeIcon icon={faListCheck} />
    </span>
    <span className="nav-text">Manage Book</span>
  </a>
</li>
<li className="nav-item">
  <a className="nav-link text-light" href="/adminpurchase">
    <span className="nav-icon">
      <FontAwesomeIcon icon={faCartShopping} />
    </span>
    <span className="nav-text">Purchase History</span>
  </a>
</li>
<li className="nav-item">
  <a className="nav-link text-light" href="/adminrent">
    <span className="nav-icon">
      <FontAwesomeIcon icon={faBagShopping} />
    </span>
    <span className="nav-text">Rental History</span>
  </a>
</li>
</ul>
    
    <ul className="navbar-nav ml-auto pr-5">
      <li className="nav-item mr-5">
        <a className="nav-link text-light fixed-right" href="#logout">
          <FontAwesomeIcon icon={faRightFromBracket} /> Logout
        </a>
      </li>
    </ul>
  </div>
</nav>

<div className="container edit-book-container mt-5 pt-5">
      <h2 className="text-center mb-4">Edit Book Details</h2>

      
  {notification && (
        <div
          style={{
            position: "fixed",
            top: "30px",
            right: "20px",
            backgroundColor: notification.type === "success" ? "#28a745" : "#dc3545",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "5px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            zIndex: 9999,
          }}
        >
          {notification.message}
        </div>
      )}
      
      <form onSubmit={handleSubmit} className="form-container">
        <div className="mb-3">
          <label className="form-label">Book Title</label>
          <input
            type="text"
            className="form-control"
            name="title"
            value={bookDetails.title}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Author</label>
          <input
            type="text"
            className="form-control"
            name="author"
            value={bookDetails.author}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Publisher</label>
          <input
            type="text"
            className="form-control"
            name="publisher"
            value={bookDetails.publisher}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Stock</label>
          <input
            type="number"
            className="form-control"
            name="stock"
            value={bookDetails.stock}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Price</label>
          <input
            type="number"
            className="form-control"
            name="price"
            value={bookDetails.price}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit" className="btn btn-primary w-100">
          Update Book
        </button>
      </form>
    </div>

      
      <style jsx>{`
 .edit-book-container {
  max-width: 500px;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

 .form-container {
   max-width: 500px;
   width: 100%;
   padding: 20px;
   border-radius: 10px;
   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
 }

 
       .content {
         margin-left: 200px;
       }
       @media (max-width: 768px) {
         .vertical-nav {
           width: 100%;
         }
         .content {
           margin-left: 0;
         }
       }
 .navbar {
   background: #1a1a1a; /* Dark background color */
 }

 .vertical-nav {
   background: #1a1a1a; /* Dark background color */
   position: fixed;
   top: 56px;
   left: 0;
   height: calc(100% - 56px);
   overflow-y: auto;
   padding-top: 30px;
   z-index: 999;
 }

 .vertical-nav .nav-link {
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   padding: 10px 15px;
   color: #ff6700; /* Dark orange font color */
   transition: background-color 0.3s; /* Smooth hover effect */
 }

 .vertical-nav .nav-link:hover {
   background-color: #2a2a2a; /* Slightly lighter background for hover effect */
 }

 .nav-icon {
   font-size: 20px;
   margin-right: 10px;
   color: #ff6700; /* Dark orange for icons */
 }

 li {
   border-bottom: 2px solid black;
 }

 li:hover {
   background-color: #2a2a2a; /* Slightly lighter background for hover effect */
 }


 .btn {
   width: 100%; /* Full-width button */
   background-color: #ff6700; /* Dark orange background for button */
    maxWidth: 400px,

   color: white;
   border: none;
   padding: 10px;
   font-size: 16px;
   font-weight: bold;
   border-radius: 5px;
 }

 .btn:hover {
   background-color: #e65c00; /* Darker orange on hover */
   cursor: pointer;
 }

 body {
   position: relative;
   margin: 0; /* Remove default margins */
   padding: 0; /* Remove default padding */
 }

 body::before {
   content: '';
   position: fixed;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   background: url('https://wallpaperaccess.com/full/934072.jpg') no-repeat center center fixed;
   background-size: cover; /* Ensure the image covers the entire body */
   opacity: 0.4; /* Apply opacity only to the image */
   z-index: -1; /* Place it behind all other content */
 }

 a {
   text-decoration: none;
 }

 h1, h2, h3, h4, h5, h6 {
   font-family: "Times New Roman", Times, serif; /* Classic font */
   color: #1a1a1a; /* Match the theme color */
 }
     `}</style>
    </div>
  );
};

export default EditBook;
